import API from "store/api"
import { toggleFacebookConnected } from "./facebookConnectedDialog"

export const getLinkedInAuthCode = () => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/social/linkedin/auth`)
      .then(res => {
        // console.log(res.body)
        window.location = res.body.url
        resolve(res)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
  return deferred
}

export const getLinkedInOrgs = () => dispatch => {
  return new Promise((resolve, reject) => {
    API.get(`/social/linkedin/orgs`)
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/actions/linkedIn.js